import { useEffect } from "react";

// Tab icon for a tenant site: the template favicon, else the logo, else the platform icon.
// scripts/generate-tenant-shells.js applies the same rule to the static tenant HTML files.
export const getSiteIcon = (websiteData) =>
  websiteData?.home_config?.faviconURL ||
  websiteData?.home_config?.logoURL ||
  websiteData?.logo_url ||
  "/favicon.png";

export const useSiteBranding = (pageTitle, websiteData) => {
  useEffect(() => {

    const companyName = websiteData?.home_config?.companyName || "Ezy Freight Logistics";
    const faviconURL = getSiteIcon(websiteData);

    if (companyName) {
      document.title = pageTitle ? `${pageTitle} - ${companyName}` : companyName;
    }

    if (faviconURL) {
      const selectors = [
        "link[rel='icon']",
        "link[rel='shortcut icon']",
        "link[rel='apple-touch-icon']",
      ];

      selectors.forEach((selector) => {
        document.querySelectorAll(selector).forEach((link) => {
          link.href = faviconURL;
        });
      });

      // Fallback: create one if none exist at all
      if (!document.querySelector("link[rel~='icon']")) {
        const link = document.createElement("link");
        link.rel = "icon";
        link.href = faviconURL;
        document.head.appendChild(link);
      }
    }
  }, [pageTitle, websiteData]);
};
